import { useCallback, useRef, useState } from "react";
import { useLocalStorage, useUnmount, useUpdateEffect } from "react-use";
import debounce from "lodash/debounce";

const options = {
  timeout: 300,
};

export const useDraft = (key, { timeout } = options) => {
  const [value, setValue, removeValue] = useLocalStorage(key);
  const [state, setState] = useState(() => value);
  const debounceRef = useRef(debounce(setValue, timeout)).current;

  useUpdateEffect(() => {
    if (state) {
      debounceRef(state);
    }
  }, [state]);

  useUnmount(() => {
    if (debounceRef && typeof debounceRef.flush === "function") {
      debounceRef.flush();
    }
  });

  const remove = useCallback(() => {
    setState(null);
    removeValue();
  }, [removeValue]);

  return [state, setState, remove];
};
